<template>
  <b-container>
    <b-row>
      <transition name="fade" appear>
        <b-col cols="12" class="search-full mb-4" v-if="showSearch">
          <b-input-group class="search-form">
            <template v-slot:prepend>
              <b-icon-search class="cursor" />
            </template>
            <template v-slot:append>
              <b-link
                href="#"
                class="search-clear"
                :class="showClear ? `active` : ``"
                @click="clearKeyword"
              >
                CLEAR
              </b-link>
              <b-icon-x
                class="search-close"
                :class="!showClear ? `active` : ``"
                @click="closeSearch"
              />
            </template>
            <b-form-input
              v-focus
              v-model="keyword"
              @keyup="searchSubscriptions"
            ></b-form-input>
          </b-input-group>
        </b-col>
      </transition>

      <b-col cols="10" class="p-0 mb-2">
        <h4 class="font-weight-bold">Manage Subscriptions</h4>
        <p class="grey-dark" v-if="!loading && (!list || list.length === 0)">
          <small> No results found </small>
        </p>
      </b-col>

      <b-col cols="2" class="search-trigger pr-0 pr-md-3">
        <b-icon-search
          class="cursor"
          v-if="!showSearch && showSearchButton"
          @click=";(showSearch = true), (showSearchButton = false)"
        />
      </b-col>
    </b-row>

    <transition name="fade">
      <b-row v-if="list && list.length > 0" align-v="center">
        <b-col
          v-for="(influencer, index) in list"
          :key="index"
          class="overflow-hidden text-left gradient-border py-3 m-0 cursor"
          cols="12"
          md="6"
        >
          <b-row align-v="center">
            <b-col
              cols="3"
              md="2"
              class="pointer-event p-0 pl-3 pr-1"
              @click="
                $router.push(
                  '/account/subscription/' +
                    influencer.influencer_uid +
                    `/` +
                    influencer.username
                )
              "
            >
              <div
                class="rounded-circle"
                v-if="influencer"
                :style="
                  `background:url(` +
                  influencer.profile_photo_url +
                  `) center/cover;
                    padding: 50%`
                "
              />
            </b-col>

            <b-col
              cols="5"
              md="5"
              class="pointer-event"
              @click="
                $router.push(
                  '/account/subscription/' +
                    influencer.influencer_uid +
                    `/` +
                    influencer.username
                )
              "
            >
              <p
                class="d-block font-weight-bold overflow-hidden m-0"
                v-if="influencer.full_name"
                v-text="influencer.full_name"
              />
              <small
                class="grey-light d-block"
                v-if="influencer"
                v-text="`@` + influencer.username"
              />
            </b-col>

            <b-col cols="3" md="3" class="pr-0">
              <b-link
                class="text-white float-left px-3 py-2"
                :to="
                  `/account/subscription/` +
                  influencer.influencer_uid +
                  `/` +
                  influencer.username
                "
              >
                <small>Manage</small>
              </b-link>
            </b-col>
          </b-row>
        </b-col>

        <b-col v-if="has_more" class="text-center m-auto pt-4" cols="12">
          <a href="javascript:;" @click="loadInfluencers">
            <b-spinner v-if="loading" small class="mr-2" />
            <small>show more +</small>
          </a>
        </b-col>
      </b-row>
    </transition>
  </b-container>
</template>

<script>
import _ from 'lodash'
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  name: 'ManageSubscriptionPage',
  data() {
    return {
      keyword: '',
      showSearchButton: true,
      showSearch: false,
      showClear: false,
      loading: false,
      limit: 10,
      page: 1,
    }
  },

  directives: {
    focus: {
      inserted: function (el) {
        el.focus()
      },
    },
  },

  computed: {
    ...mapState({
      list: (state) => state.subscription.influencers,
      has_more: (state) => state.subscription.has_more,
    }),

    params() {
      return {
        limit: this.limit,
        page: this.page,
        search: this.keyword,
      }
    },
  },

  methods: {
    ...mapActions({
      getInfluencers: 'subscription/getInfluencers',
    }),
    ...mapMutations({
      clearInfluencers: 'subscription/clearInfluencers',
    }),

    async loadInfluencers() {
      this.loading = true

      await this.getInfluencers(this.params)

      this.loading = false
      this.page++
    },

    clearKeyword() {
      this.keyword = ''
      this.searchSubscriptions()
    },

    async closeSearch() {
      let vm = this

      vm.showSearch = false

      setTimeout(function () {
        vm.showSearchButton = true
      }, 300)
    },

    searchSubscriptions: _.debounce(function () {
      this.page = 1
      this.showClear = this.keyword !== ''

      this.clearInfluencers()
      this.loadInfluencers()
    }, 500),
  },

  async created() {
    this.loadInfluencers()
  },

  async destroyed() {
    await this.clearInfluencers()
  },
}
</script>

<style lang="scss" scoped></style>
